import React from "react";
import { Link } from "react-router-dom";

export default function BodyCard(props) {
  return (
    <div>
      {/* <div className="d-flex flex-column mx-auto col-3 p-0"> */}
      <Link to={props.route} className="d-flex flex-column p-0">
        <div className="mx-auto th-br-12 shadow-sm">
          <img
            src={props.image}
            style={{
              background:
                "linear-gradient(to right, #314755 0%, #26a0da  51%, #314755  100%)",
            }}
            alt=""
            className="p-2 th-br-12 shadow-sm"
          />
        </div>
        <div
          className="my-2 th-fw-600 th-12 text-center"
          style={{ color: "#000000", opacity: "0.8" }}
        >
          {props.label}
        </div>
      </Link>
      {/* </div> */}
    </div>
  );
}
